import VerticalNav from './VerticalNav';
import VerticalNavMasthead from './VerticalNavMasthead';
import VerticalNavItem from './VerticalNavItem';
import VerticalNavSecondaryItem from './VerticalNavSecondaryItem';
import VerticalNavTertiaryItem from './VerticalNavTertiaryItem';
import VerticalNavBrand from './VerticalNavBrand';
import VerticalNavIconBar from './VerticalNavIconBar';
import VerticalNavBadge from './VerticalNavBadge';
import VerticalNavDividerItem from './VerticalNavDividerItem';

VerticalNav.Masthead = VerticalNavMasthead;
VerticalNav.Item = VerticalNavItem;
VerticalNav.SecondaryItem = VerticalNavSecondaryItem;
VerticalNav.TertiaryItem = VerticalNavTertiaryItem;
VerticalNav.Brand = VerticalNavBrand;
VerticalNav.IconBar = VerticalNavIconBar;
VerticalNav.Badge = VerticalNavBadge;
VerticalNav.Divider = VerticalNavDividerItem;

export { VerticalNav, VerticalNavMasthead, VerticalNavItem, VerticalNavSecondaryItem, VerticalNavTertiaryItem, VerticalNavBrand, VerticalNavIconBar, VerticalNavBadge, VerticalNavDividerItem };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/VerticalNav/index.js
// module id = 379
// module chunks = 0